function initHealingProcess() {
    let triggers = document.querySelectorAll('.hover-trigger');
    let allContent = document.querySelectorAll('.healing-process__right');
    let allSubtitles = document.querySelectorAll('.healing-process__subtitle');
    let accordionTriggers = document.querySelectorAll('.accordion-trigger');
    let allMobileContent = document.querySelectorAll('.healing-process__mobile-content');

    // Check if mobile/tablet view (accordion mode)
    function isMobile() {
        return window.innerWidth <= 1121;
    }

    // Initialize desktop hover functionality
    allContent.forEach((content, index) => {
        if (index !== 0) {
            content.classList.remove('active');
        }
    });

    allSubtitles.forEach((subtitle, index) => {
        if (index !== 0) {
            subtitle.classList.remove('active');
        }
    });

    // Desktop hover functionality
    triggers.forEach(trigger => {
         trigger.addEventListener('mouseenter', function() {
            if (!isMobile()) {
                accordionTriggers.forEach((accordion) =>{
                    accordion?.classList.remove('active');
                });
                this.classList.add('active');
                
                let targetId = this.getAttribute('data-target');
                let stepNumber = this.getAttribute('data-step');
                let subtitleId = 'step-subtitle-' + stepNumber;
                
                allContent.forEach((content) =>{
                    content?.classList.remove('active');
                });
                
                allSubtitles.forEach((subtitle) => {
                    subtitle?.classList.remove('active');
                });
                
                let targetContent = document.getElementById(targetId);
                if (targetContent) {
                    targetContent.classList.add('active');
                }
                
                let targetSubtitle = document.getElementById(subtitleId);
                if (targetSubtitle) {
                    targetSubtitle.classList.add('active');
                }
            }
        });

        trigger.addEventListener('mouseleave', function() {
            // if (!isMobile()) {
            //     let targetId = this.getAttribute('data-target');
            //     let stepNumber = targetId.replace('step-content-', '');
            //     let subtitleId = 'step-subtitle-' + stepNumber;
                
            //      let targetContent = document.getElementById(targetId);
            //     if (targetContent) {
            //         targetContent.classList.remove('active');
            //     }
                
            //     let targetSubtitle = document.getElementById(subtitleId);
            //     if (targetSubtitle) {
            //         targetSubtitle.classList.remove('active');
            //         // accordionTriggers.forEach((accordion) =>{
            //         //     accordion?.classList.remove('active');
            //         // });
            //         //this.classList.remove('active');
            //     }
                
            //     if (allContent.length > 0 && allContent[0]) {
            //         allContent[0].classList.add('active');
            //     }
                
            //     if (allSubtitles.length > 0 && allSubtitles[0]) {
            //         allSubtitles[0].classList.add('active');
            //     }
            // }
        });
    });

    // Mobile accordion functionality
    accordionTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            // Prevent closing if the click originated inside the accordion content itself
            if (e.target.closest('.healing-process__mobile-content')) {
                return;
            }

            if (isMobile()) {

                // REMOVE THESE
                // e.preventDefault();
                // e.stopPropagation();

                const currentScrollY = window.scrollY;

                let stepNumber = this.getAttribute('data-step');
                let mobileContentId = 'mobile-step-content-' + stepNumber;
                let mobileContent = document.getElementById(mobileContentId);

                let isOpen = this.classList.contains('accordion-open');

                // Close all
                accordionTriggers.forEach(t => {
                    t.classList.remove('accordion-open');
                    t.classList.remove('active');
                });

                allMobileContent.forEach(content => {
                    content.classList.remove('active');
                    content.style.height = '0px'; // Reset height explicitly to 0 for smooth close transition
                });

                if (!isOpen && mobileContent) {
                    // Open the clicked one
                    this.classList.add('accordion-open');
                    this.classList.add('active');
                    mobileContent.classList.add('active');
                    
                    // Set height to actual scrollHeight for smooth animation
                    mobileContent.style.height = "auto";
                    
                    setTimeout(() => {
                        const stepContent = this.querySelector('.healing-process__step-content');
                        if (stepContent) {
                            const rect = stepContent.getBoundingClientRect();
                            const headerOffset = 120; // Accounts for sticky header
                            
                            // Check if the step content (title/header) is out of the viewport
                            if (rect.top < headerOffset || rect.bottom > window.innerHeight) {
                                const yOffset = -120; 
                                const y = rect.top + window.scrollY + yOffset;
                                window.scrollTo({top: y, behavior: 'smooth'});
                            }
                        }
                    }, 400); // slightly longer timeout to let height animation complete
                }


            } else {

                accordionTriggers.forEach((accordion) => {
                    accordion?.classList.remove('active');
                });

                this.classList.add('active');

                let targetId = this.getAttribute('data-target');

                allContent.forEach((content) => {
                    content?.classList.remove('active');
                });

                let targetContent = document.getElementById(targetId);

                if (targetContent) {
                    targetContent.classList.add('active');
                }
            }
        });
    });

    // Initialize first accordion as open on mobile
    function initializeMobileAccordion() {
        if (isMobile()) {
            // Check if any accordion is already open. If so, don't force the first one open again.
            let anyOpen = document.querySelector('.accordion-open');
            if (anyOpen) return;

            let firstTrigger = document.querySelector('.accordion-trigger[data-step="1"]');
            let firstMobileContent = document.getElementById('mobile-step-content-1');
            
            if (firstTrigger && firstMobileContent) {
                firstTrigger.classList.add('accordion-open');
                firstMobileContent.classList.add('active');
                
                // Allow browser to layout the content so we can get its height
                setTimeout(() => {
                    firstMobileContent.style.height = firstMobileContent.scrollHeight + "px";
                }, 10);
            }
        }
    }

    /**
     * Set min-height of all right (tab) content panels to the tallest panel height,
     * so the section doesn't shift when switching tabs on desktop.
     */
    function setRightColumnMinHeight() {
        if (isMobile() || !allContent.length) return;
        var maxHeight = 0;
        var i, h;
        // Temporarily show each panel one by one and measure its height
        for (i = 0; i < allContent.length; i++) {
            allContent.forEach(function(el, j) {
                el.style.display = j === i ? 'flex' : 'none';
            });
            h = allContent[i].offsetHeight;
            if (h > maxHeight) maxHeight = h;
        }
        // Set min-height on all panels (20px less than tallest) and restore display from CSS (active state)
        var heightToApply = Math.max(0, maxHeight - 30);
        allContent.forEach(function(el) {
            el.style.minHeight = heightToApply + 'px';
            el.style.display = '';
        });
    }

    /**
     * Mental wellbeing mode (desktop only): set min-height of all right panels
     * to match the left-main height.
     *
     * Instead of reading leftMain.offsetHeight (which may include phantom space
     * from the container's own gap, padding, or the per-step gap reserving space
     * for hidden mobile-content siblings), we manually sum:
     *   - Each direct .healing-process__step's offsetHeight (only visible content)
     *   - The computed margin-bottom between steps (excluding last)
     * This gives the exact rendered height with zero inflation.
     */
    function syncRightToLeftMainHeight() {
        if (isMobile()) return;
        if (!document.querySelector('.mental-wellbeing-styling-enabled')) return;

        var leftMain = document.querySelector('.healing-process__left-main');
        if (!leftMain || !allContent.length) return;

        // Sum only the direct step children heights + margin-bottom between them
        var steps = Array.from(leftMain.querySelectorAll(':scope > .healing-process__step'));
        if (!steps.length) return;

        var totalHeight = 0;
        steps.forEach(function(step, index) {
            totalHeight += step.offsetHeight;
            if (index < steps.length - 1) {
                // Read actual computed margin-bottom so we stay in sync with CSS
                var mb = parseFloat(window.getComputedStyle(step).marginBottom) || 0;
                totalHeight += mb;
            }
        });

        allContent.forEach(function(el) {
            el.style.minHeight = totalHeight + 'px';
            el.style.maxHeight = totalHeight + 'px';
        });
    }

    // Initialize on load
    initializeMobileAccordion();
    setRightColumnMinHeight();
    syncRightToLeftMainHeight();


    // Re-initialize on resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (isMobile()) {
                initializeMobileAccordion();
                allContent.forEach(function(el) { el.style.minHeight = ''; el.style.maxHeight = ''; });
            } else {
                setRightColumnMinHeight();
                syncRightToLeftMainHeight();
                // Reset desktop state
                accordionTriggers.forEach(t => {
                    t.classList.remove('accordion-open');
                });
                allMobileContent.forEach(content => {
                    content.classList.remove('active');
                });
            }
        }, 250);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHealingProcess);
} else {
    initHealingProcess();
}